import { render, staticRenderFns } from "./ChargeWallet.vue?vue&type=template&id=234c4c38&scoped=true"
import script from "./ChargeWallet.vue?vue&type=script&lang=js"
export * from "./ChargeWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c4c38",
  null
  
)

export default component.exports